import * as angular from "angular";
import {IController} from "angular";
import {CustomerType} from "../../angular/types/customer-type.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CustomersAlerts} from "../../services/customers-alerts.service";
import {CustomersDialogService} from "../../services/customers-dialogs-service.service";
import {CustomersRequests} from "../../services/customers-requests.service";

export class customerViewCtrl implements IController {

  customer: any;

  public customerTypes: typeof CustomerType = CustomerType;

  constructor(private customersDialogService: CustomersDialogService, private customersRequests: CustomersRequests, private $log,
              private customersAlerts: CustomersAlerts, private bringozLoaderService: BringozLoaderService, private $filter) {
  }

  $onInit() {

  }


  onEdit(event) {
    this.customersDialogService.editCustomer(event, this.customer)
      .then((customerToUpdate) => {
        customerToUpdate.phone = this.$filter('bringozPhonePrefix')(customerToUpdate.phone);
        this.bringozLoaderService.on();
        return this.customersRequests.updateCustomer(this.customer.id, customerToUpdate)
      })
      .then(() => {
        this.customersAlerts.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.customersAlerts.updateError();
          this.$log.error('Failed to update customer @customerView@onEdit', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }


}

angular
  .module('bringoz.admin.customers')
  .component('customerView', {
    bindings: {
      customer: '<'
    },
    template: require('./customer-view.html').default,
    controller: customerViewCtrl
  });
